export default __webpack_public_path__ + "static/media/howTo3.2c394daa.svg";